// extracted by mini-css-extract-plugin
export var accentAnimated = "Title-module--accent-animated--zPokA";
export var accentFadeIn = "Title-module--accent-fade-in--9EcgK";
export var titleAnimated = "Title-module--title-animated--V4YTo";
export var titleFadeIn = "Title-module--title-fade-in--WKXGW";